module.exports = __webpack_public_path__ + "static/media/iconList.af9fa439.png";